import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export function formatBytes(bytes: number): string {
  if (bytes === 0) return "0 B";
  const k = 1024;
  const sizes = ["B", "KB", "MB", "GB"];
  const i = Math.floor(Math.log(bytes) / Math.log(k));
  return `${parseFloat((bytes / Math.pow(k, i)).toFixed(2))} ${sizes[i]}`;
}

export function getSlug(title: string): string {
  return title
    .toLowerCase()
    .replace(/[^\w\s]/gi, "")
    .replace(/\s+/g, "-");
}

export function getWordCount(htmlContent: string): number {
  // Create a temporary element to parse HTML
  const tempDiv = document.createElement("div");
  tempDiv.innerHTML = htmlContent;

  // Get text content and normalize
  let text = tempDiv.textContent || tempDiv.innerText || "";
  text = text
    .replace(/\s+/g, " ") // Replace multiple spaces with single space
    .replace(/[^\w\s-']/g, "") // Remove punctuation except hyphens and apostrophes
    .trim(); // Remove leading/trailing spaces

  // Split by spaces and filter out empty strings
  const words = text.split(" ").filter((word) => word.length > 0);

  return words.length;
}

export function detectContentType(
  content: string,
): "html" | "markdown" | "plain" {
  // Trim whitespace
  const trimmedContent = content.trim();

  // HTML patterns: tags, attributes, or closing tags
  const htmlRegex = /<[a-zA-Z][^>]*>|<\/[a-zA-Z]+>/;
  // Markdown patterns: headings, lists, links, bold/italic
  const markdownRegex =
    /^(#{1,6}\s|[-*]\s|\d+\.\s|\[.*\]\(.*\)|(\*\*|__)[^*_]+(\*\*|__)|(\*|_)[^*_]+(\*|_))/m;

  // Check for HTML
  if (htmlRegex.test(trimmedContent)) {
    return "html";
  }

  // Check for Markdown
  if (markdownRegex.test(trimmedContent)) {
    return "markdown";
  }

  // Fallback to plain text
  return "plain";
}
